import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

const errorMsg =
  'Missing GoogleReCaptchaProvider or script not successfully loaded.';

export default function useRecaptcha() {
  const recaptcha = useGoogleReCaptcha();

  return {
    executeRecaptcha: async (action: string) => {
      // executeRecaptcha is undefined if it failed to load the script https://github.com/t49tran/react-google-recaptcha-v3#react-hook-usegooglerecaptcha-recommended-approach
      if (!recaptcha.executeRecaptcha) {
        throw new Error(errorMsg);
      }

      return recaptcha.executeRecaptcha(action);
    },
  };
}
